import axios from 'axios';
import {baseURL} from '../components/base_url'

const axiosInstance = axios.create({
  baseURL: baseURL
});

// Add request interceptor
axiosInstance.interceptors.request.use(
  config => {
    const loggedInUser = sessionStorage.getItem("tm_token");
    const foundUser = JSON.parse(loggedInUser);
    const authToken = foundUser['auth_token'];
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Add response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Handle 401 Unauthorized errors here if needed
    if (error.response && error.response.status === 401) {
      // Clear session storage and redirect to login
      sessionStorage.clear();
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;